<template>
  <div>
    <h3>审批产品信息</h3>
    <div class="bill-box" v-for="(item, index) in selectData" :key="index">
      <div class="bill-label">寻样单信息:</div>
      <OutsideSample :showLog="false" :id="item.id" @return-sample-data="returnSampleData($event, index)" />
      <div class="bill-label" style="margin-top: 10px;">审批意见:</div>
      <el-form
        ref="confirmInfoForm"
        style="width: 100%"
        :model="item"
        label-width="100px"
        size="mini"
        :rules="rules"
      >
        <el-form-item label="审批结果" prop="leaderStatus">
          <DictSelect
            type="cml_sample_checkstatus"
            :value="item.leaderStatus"
            @change-emit="checkStatusChange($event, index)"
          />
        </el-form-item>
        <div v-if="item.leaderStatus === 'NO_PASS'">
          <el-form-item label="理由" prop="leadApprovalOpinion">
            <el-input
              style="width: 300px"
              type="textarea"
              placeholder="请输入内容"
              v-model="item.leadApprovalOpinion"
              maxlength="30"
              size="mini"
              show-word-limit
            />
          </el-form-item>
        </div>
      </el-form>
    </div>

    <div style="text-align: center; margin-bottom: 20px;">
      <el-button type="primary" @click="save" :loading="saveLoading">提交</el-button>
      <el-button @click="cancelBtn">取消</el-button>
    </div>
    <!-- 供应商 -->
    <AddProduct
      ref="addProduct"
      :title="'supplier'"
      :type="formData.productType"
      :leftTitle="titleList"
      :rightTitle="titleList"
      @close="addSupplier"
    />
  </div>
</template>
<script>
import DictSelect from '@/components/DictSelect';
import AddProduct from '@/components/AddProductDialog';
import OutsideSample from '@/components/OutsideSample';
import { unionBy } from 'lodash';
export default {
  components: { DictSelect, AddProduct, OutsideSample },
  props: {
    removeTab: {
      type: Function,
      default: null,
    },
  },
  data: () => ({
    selectData: [],
    formData: {
      checkStatus: '',
      askArrivalTime: '',
      forSupplierRemark: '',
      supplierList: [],
      checkRemark: '',
    },
    saveLoading: false,
    rules: {
      leaderStatus: [
        { required: true, message: '请选择审批结果', trigger: 'change' },
      ],
      leadApprovalOpinion: [
        { required: true, message: '请输入理由', trigger: 'blur' },
      ]
    },
    expireTimeOption: {
      disabledDate: (time) => {
        return time.getTime() < Date.now() - 8.64e7;
      },
    },
    dialogVisible: false,
    titleList: [
      { prop: 'name', label: '供应商名称' },
      { prop: 'categoryName', label: '供应商大类' },
    ],
    detailData: {},
    $index: null
  }),
  mounted() {},
  methods: {
    getDetail(arr) {
      this.selectData = [...arr].map(item => {
        return {
          ...item,
          leaderStatus: '',
          leadApprovalOpinion: ''
        }
      });
      this.$nextTick(() => {
        this.clearConfirmInfoForm();
      });
    },
    checkStatusChange(val, index) {
      // 清空审批数据
      const item = this.selectData[index];
      this.$set(item, 'leaderStatus', val);
      this.$set(item, 'leadApprovalOpinion', '');
      this.$refs.confirmInfoForm[index].clearValidate();
    },
    returnSampleData(obj, index) {
      const item = this.selectData[index];
      this.$set(item, 'detailData', obj);
    },
    save() {
      // form校验
      if (!this.checkFormValid()) {
        return;
      }
      const params = this.selectData.map(item => ({
        id: item.id,
        leadApprovalOpinion: item.leadApprovalOpinion,
        leaderStatus: item.leaderStatus
      }));
     
      this.saveLoading = true;
      this.$http.outsideSampleManage
        .oOrderLeadApproval(params)
        .then(() => {
          this.$message.success('操作成功');
          this.removeTab('detail');
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.saveLoading = false;
        });
    },
    openSupplier(index) {
      this.$index = index;
      this.$refs.addProduct.getList();
    },
    // 添加供应商
    addSupplier({data}) {
      const item = this.selectData[this.$index];
      this.$set(item, 'supplierList', unionBy(item.supplierList, data, 'name'));
      item.supplierList.length > 0 && this.$refs.confirmInfoForm[this.$index].clearValidate('supplierList');
    },
    deleteBtn(index) {
      this.selectData[this.$index].supplierList.splice(index, 1);
    },
    // 清空form表单
    clearConfirmInfoForm() {
      this.$nextTick(() => {
        this.$refs.confirmInfoForm.map(el => {
          el.resetFields();
        });
      });
    },
    checkFormValid() {
      let formValid = []; // 正确数据
      this.$refs.confirmInfoForm.map(item => {
        item.validate(valid => {
          formValid.push(valid)
        });
      });
      return formValid.every(Boolean);
    },
    cancelBtn() {
      this.removeTab('detail');
    }
  },
};
</script>
<style lang="less" scoped>
h3 {
  text-align: center;
  margin-bottom: 10px;
}
.bill-box {
  padding: 0 20px;
  margin-bottom: 30px;
  border-bottom: 1px dashed #ccc;
  form {
    margin-left: 125px;
  }
}
.bill-label {
  width: 130px;
  font-weight: bold;
}
.supplier-list {
  p {
    position: relative;
    width: 300px;
    padding-right: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    i {
      position: absolute;
      right: 0;
      top: 8px;
      &:hover {
        cursor: pointer;
        color: #f00;
      }
    }
  }
}
</style>